import {
    apiRequest,
    HDdetail,
    HDUploadSK,
    masterPunishment,
    HDUploadHasil
} from "../../../../../services/adapters/kepegawaian/hukumanDisiplinService"

class UpdateRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", HDdetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", HDUploadSK, {
            body: query
        }, true)
    }
    fetchUpdatedokumen = async (query) => {
        return await apiRequest("post", HDUploadHasil, {
            body: query
        }, true)
    }

    fetchPunishment = async (query) => {
        return await apiRequest("get", masterPunishment, {
            params: query
        }, true)
    }
}

export default UpdateRepository